import { PageHeader, Section } from "@/components/Section";

export default function Privacy() {
  return (
    <>
      <PageHeader
        overline="Legal"
        title="Privacy policy."
        lede="Plain language, written by people who will sign the methodology document next to it. Last updated June 2026."
        testid="privacy-page-header"
      />

      <Section testid="privacy-content" className="!pt-16">
        <div className="max-w-prose prose-continuum">
          <p>
            This policy covers <strong>getcontinuum.com</strong> (the marketing site) and the
            waitlist / walkthrough forms hosted on it. The platform application
            (<span className="font-mono">app.getcontinuum.com</span>) has a separate, more
            detailed privacy and data-processing policy that ships with the MVP.
          </p>

          <h2>1. What we collect</h2>
          <ul>
            <li><strong>Waitlist:</strong> work email, optional name, organisation, audience type, free-text question.</li>
            <li><strong>Walkthrough requests:</strong> name, work email, organisation, role, community, free-text message.</li>
            <li><strong>Community question form:</strong> community name, work email, optional question text.</li>
            <li><strong>Server logs:</strong> request metadata (timestamp, IP, user agent) for security and abuse prevention, retained for 30 days.</li>
            <li><strong>Privacy-first analytics:</strong> aggregate page views via a cookieless analytics provider. No personal identifiers, no cross-site tracking.</li>
          </ul>

          <h2>2. What we don't collect</h2>
          <ul>
            <li>No third-party advertising cookies. No retargeting pixels. Ever.</li>
            <li>No social-login redirects. No fingerprinting libraries.</li>
            <li>No personal data is sold, rented, or shared with marketing networks.</li>
          </ul>

          <h2>3. Where your data lives</h2>
          <p>
            All form submissions are stored in databases hosted in Canadian regions. The
            marketing site itself is served from a global CDN; the data layer is Canadian.
          </p>

          <h2>4. How we use what we collect</h2>
          <ul>
            <li>To respond to your walkthrough or waitlist request, from a monitored human inbox.</li>
            <li>To send phase release and methodology update notes — only to addresses on the waitlist, only when there's something material to say. Unsubscribe in every message.</li>
            <li>To improve the platform's research priorities (which communities are asking which questions). Aggregated only.</li>
          </ul>

          <h2>5. Your rights</h2>
          <p>
            You can ask for a copy of your data, ask us to correct it, or ask us to delete it,
            at any time. We will respond within 30 days. There is no form to fill in — email
            us at <a href="mailto:hello@getcontinuum.com" className="text-[#FF8A00] font-bold underline underline-offset-4">hello@getcontinuum.com</a>.
          </p>

          <h2>6. Children</h2>
          <p>
            This site is intended for professionals working in the social sector. We do not
            knowingly collect personal data from individuals under 16. If we learn we have,
            we delete it.
          </p>

          <h2>7. Changes</h2>
          <p>
            Material changes to this policy will be announced on the homepage and in a
            waitlist email before they take effect. Minor clarifications will be noted with a
            new "last updated" date at the top of this page.
          </p>

          <h2>8. Contact</h2>
          <p>
            Privacy questions go to <a href="mailto:hello@getcontinuum.com" className="text-[#FF8A00] font-bold underline underline-offset-4">hello@getcontinuum.com</a>.
          </p>
        </div>
      </Section>
    </>
  );
}
